import { render, staticRenderFns } from "./TheBuddha.vue?vue&type=template&id=5d9bdcb0&scoped=true&"
import script from "./TheBuddha.vue?vue&type=script&lang=js&"
export * from "./TheBuddha.vue?vue&type=script&lang=js&"
import style0 from "./TheBuddha.vue?vue&type=style&index=0&id=5d9bdcb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9bdcb0",
  null
  
)

export default component.exports